import store from "@/store";
import VueCookies from "vue-cookies";

const FONT_STYLE_ID = "dynamic-font-face";

let lastFontConfig = null;

function refreshFont() {
  if (lastFontConfig) {
    genarateFont(lastFontConfig.data, lastFontConfig.layout);
  }
}

function genarateFont(data, layout) {
  lastFontConfig = { data, layout };
  let bodyStyles = document.body.style;

  if (data.font_size_detail) {
    const fontList = data.font_size_detail.filter(
      el => el.font_size_id == data.font_size
    );

    if (data.font_size == "2") {
      bodyStyles.setProperty(
        "--font-caption",
        (fontList[0]?.value || "8") + "px"
      );
      bodyStyles.setProperty(
        "--font-helper",
        (fontList[1]?.value || "10") + "px"
      );
      bodyStyles.setProperty(
        "--font-body-sm",
        (fontList[2]?.value || "12") + "px"
      );
      bodyStyles.setProperty(
        "--font-body",
        (fontList[3]?.value || "14") + "px"
      );
      bodyStyles.setProperty(
        "--font-body-lg",
        (fontList[4]?.value || "16") + "px"
      );
      bodyStyles.setProperty(
        "--font-title-sm",
        (fontList[5]?.value || "18") + "px"
      );
      bodyStyles.setProperty(
        "--font-title",
        (fontList[6]?.value || "22") + "px"
      );
      bodyStyles.setProperty(
        "--font-heading",
        (fontList[7]?.value || "26") + "px"
      );
    } else if (data.font_size == "3") {
      bodyStyles.setProperty(
        "--font-caption",
        (fontList[0]?.value || "10") + "px"
      );
      bodyStyles.setProperty(
        "--font-helper",
        (fontList[1]?.value || "12") + "px"
      );
      bodyStyles.setProperty(
        "--font-body-sm",
        (fontList[2]?.value || "14") + "px"
      );
      bodyStyles.setProperty(
        "--font-body",
        (fontList[3]?.value || "16") + "px"
      );
      bodyStyles.setProperty(
        "--font-body-lg",
        (fontList[4]?.value || "18") + "px"
      );
      bodyStyles.setProperty(
        "--font-title-sm",
        (fontList[5]?.value || "20") + "px"
      );
      bodyStyles.setProperty(
        "--font-title",
        (fontList[6]?.value || "24") + "px"
      );
      bodyStyles.setProperty(
        "--font-heading",
        (fontList[7]?.value || "28") + "px"
      );
    } else if (data.font_size == "1") {
      bodyStyles.setProperty(
        "--font-caption",
        (fontList[0]?.value || "6") + "px"
      );
      bodyStyles.setProperty(
        "--font-helper",
        (fontList[1]?.value || "8") + "px"
      );
      bodyStyles.setProperty(
        "--font-body-sm",
        (fontList[2]?.value || "10") + "px"
      );
      bodyStyles.setProperty(
        "--font-body",
        (fontList[3]?.value || "13") + "px"
      );
      bodyStyles.setProperty(
        "--font-body-lg",
        (fontList[4]?.value || "14") + "px"
      );
      bodyStyles.setProperty(
        "--font-title-sm",
        (fontList[5]?.value || "16") + "px"
      );
      bodyStyles.setProperty(
        "--font-title",
        (fontList[6]?.value || "20") + "px"
      );
      bodyStyles.setProperty(
        "--font-heading",
        (fontList[7]?.value || "24") + "px"
      );
    }
  }
  const formatOf = url => {
    const ext = url.split(".").pop().toLowerCase();
    if (ext === "otf") return "opentype";
    if (ext === "woff2") return "woff2";
    if (ext === "woff") return "woff";
    return "truetype";
  };

  document.getElementById(FONT_STYLE_ID)?.remove();
  const newStyle = document.createElement("style");
  newStyle.id = FONT_STYLE_ID;
  let fontFaces = "";

  if (layout === "Lacoste" || layout === "standard-v2") {
    const langId = VueCookies.get("lang")?.lang;
    const isThai = langId == 1 || langId == null;

    const thaiFont =
      layout === "Lacoste"
        ? "/font/NotoSansThai-Regular.ttf"
        : "/font/Kanit-light.ttf";
    const latinFont =
      layout === "Lacoste"
        ? "/font/Mona-Sans-Regular.ttf"
        : "/font/Gotham-Light.otf";
    const primaryFont = isThai ? thaiFont : latinFont;

    fontFaces = [400, 500, 600]
      .map(
        weight => `@font-face {
          font-family: 'CustomFont';
          src: url('${primaryFont}') format('${formatOf(primaryFont)}');
          font-weight: ${weight};
          font-display: swap;
        }`
      )
      .join("\n");
  } else {
    const fontRegular = "/font/Kanit-light.ttf";
    const fontBold = "/font/Kanit-Bold.ttf";
    const regularSrc = data.custom_font
      ? store.state.domain + data.custom_font.substring(1)
      : fontRegular;
    const boldSrc = data.custom_font_bold
      ? store.state.domain + data.custom_font_bold.substring(1)
      : fontBold;

    fontFaces = `
      @font-face {
        font-family: 'CustomFont';
        src: url('${regularSrc}') format('${formatOf(regularSrc)}');
        font-weight: 400;
        font-display: swap;
      }
      @font-face {
        font-family: 'CustomFont';
        src: url('${boldSrc}') format('${formatOf(boldSrc)}');
        font-weight: 500;
        font-display: swap;
      }
      @font-face {
        font-family: 'CustomFont';
        src: url('${boldSrc}') format('${formatOf(boldSrc)}');
        font-weight: 600;
        font-display: swap;
      }
    `;
  }

  newStyle.appendChild(document.createTextNode(fontFaces));
  document.head.appendChild(newStyle);
}

export { genarateFont, refreshFont };
